import { useParticipant } from "../../contexts/ParticipantContext";
import { Participant } from "../../models/Participant";
import { useState } from "react";
import { Table, TableBody, TableCell, TableRow } from "../../design/table";
import { Button } from "../../design/button";
import SelectParticipantDialog from "../Dialogs/SelectParticipantDialog/SelectParticipantDialog";
import { PlusIcon, XMarkIcon } from "@heroicons/react/20/solid";
import { Field } from "@headlessui/react";
import { Label } from "../../design/fieldset";

interface SelectParticipantFieldProps {
  label: string;
  value: Participant["_id"] | null;
  onChange: (value: Participant["_id"] | null) => void;
}

const SelectParticipantField: React.FC<SelectParticipantFieldProps> = ({
  label,
  value,
  onChange,
}) => {
  const { participants } = useParticipant();
  const [showParticipantDialog, setShowParticipantDialog] = useState(false);

  const onParticipantSelected = (participant: Participant) => {
    onChange(participant._id);
    setShowParticipantDialog(false);
  };

  const removeParticipant = () => {
    onChange(null);
  };

  const selectedParticipant = participants.find((p) => p._id === value);

  return (
    <Field>
      <div className="flex items-center justify-between mb-2">
        <Label>{label}</Label>
        <Button onClick={() => setShowParticipantDialog(true)}>
          <PlusIcon className="w-5 h-5 mr-2" />
        </Button>
      </div>

      <SelectParticipantDialog
        isOpen={showParticipantDialog}
        participants={participants}
        onClose={() => setShowParticipantDialog(false)}
        onParticipantSelected={onParticipantSelected}
      />

      <div className="overflow-hidden border rounded-lg">
        <Table>
          <TableBody>
            {selectedParticipant ? (
              <TableRow>
                <TableCell>{selectedParticipant.name}</TableCell>
                <TableCell className="text-right">
                  <Button color="red" onClick={removeParticipant}>
                    <XMarkIcon className="w-5 h-5" />
                  </Button>
                </TableCell>
              </TableRow>
            ) : (
              <TableRow>
                <TableCell colSpan={2} className="text-center text-gray-500">
                  No participant selected
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
    </Field>
  );
};

export default SelectParticipantField;
